import { fetchWithAuth } from "./fetchWithAuth";

export async function loadStoreOptions(inputValue: string) {
  try {
    const response = await fetchWithAuth(
      `/stores?search=${encodeURIComponent(inputValue)}&sort=ascending`
    );
    const data = await response.json();

    return (data.stores ?? []).map((store: any) => ({
      label: `${store.name}`,
      value: store.id
    }));
  } catch {
    // fetchWithAuth already surfaced the error; the select just shows no options.
    return [];
  }
};
